// extracted by mini-css-extract-plugin
export default {"card":"changePasswordPage_card__35uFk","spinner":"changePasswordPage_spinner__vpBPL","input":"changePasswordPage_input__hgn7K","feedback":"changePasswordPage_feedback__6gL-T"};